//deps
import { CHANGE, CHANGE_PAYMENT_CTA_ARIA_LABEL } from "@payment-ui/constants/TurboPayment";
import { ACCESSIBILITY_ROLES } from "@payment-ui/constants";
import { TURBO_PAYMENT_WIDGET_DATA_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { handleKeyboardActivation } from "@swiggy-private/core-ui";
import React, { memo } from "react";
import Chevron from "./Chevron";

//styles
import {
    MainContainer,
    ChangeButtonWrapperV1,
    ChangePaymentCtaContainerV1,
    ChevronContainer,
} from "./styles/ChangePaymentCta.style";

interface ChangePaymentCtaProps {
    dataTestId: string;
    className?: string;
    onClick?: VoidFunction;
}

function ChangePaymentCta({ className, onClick, dataTestId }: ChangePaymentCtaProps) {
    return (
        <MainContainer data-testid={dataTestId}>
            <ChangeButtonWrapperV1>
                <ChangePaymentCtaContainerV1
                    variant="V2.body2.neutral.bold"
                    color="primary"
                    className={className}
                    onClick={onClick}
                    onKeyDown={handleKeyboardActivation(onClick)}
                    role={ACCESSIBILITY_ROLES.BUTTON}
                    tabIndex={0}
                    data-testid={TURBO_PAYMENT_WIDGET_DATA_TEST_IDS.CHANGE_PAY_CTA}
                    aria-label={CHANGE_PAYMENT_CTA_ARIA_LABEL}
                >
                    {CHANGE}
                </ChangePaymentCtaContainerV1>
            </ChangeButtonWrapperV1>
            <ChevronContainer>
                <Chevron />
            </ChevronContainer>
        </MainContainer>
    );
}

export default memo(ChangePaymentCta);
